import { create } from 'zustand';

let nextId = 1;

/**
 * @typedef {object} Notification
 * @property {number} id
 * @property {'success'|'error'|'info'} kind
 * @property {string} message
 * @property {number} createdAt
 */

export const useNotifyStore = create(
  /** @param {import('zustand').SetStateFn<{toasts: Notification[]}>} set */
  (set) => ({
    toasts: /** @type {Notification[]} */ ([]),

    notify: (kind, message, duration = 4000) => {
      const id = nextId++;
      set((s) => ({
        toasts: [...s.toasts, { id, kind, message, createdAt: Date.now() }],
      }));
      if (duration > 0) {
        setTimeout(() => {
          set((s) => ({
            toasts: s.toasts.filter((t) => t.id !== id),
          }));
        }, duration);
      }
    },

    dismiss: (id) =>
      set((s) => ({
        toasts: s.toasts.filter((t) => t.id !== id),
      })),
  }),
);
